<template>
  <v-form v-bind="this.$attrs">
    <v-row>
      <div class="inputSearch">
        <v-row>
          <v-col cols="12" md="4" lg="4">
            <v-text-field
              v-model="tags_contains"
              label="Nhóm đối tượng"
              return-object
              clearable
              flat
              outlined
              dense
              hide-details
              @keyup.enter="onFilterChange"
            />
          </v-col>
          <v-col cols="12" md="4" lg="4">
            <v-select
              v-model="category"
              :items="classifes"
              clear-icon="mdi-close"
              item-text="name"
              item-value="value"
              label="Phân loại"
              outlined
              dense
              clearable
              hide-details
            />
          </v-col>
        </v-row>
      </div>
      <div class="buttonSearch">
        <div class="d-flex flex-column justify-start">
          <v-btn class="search-button" @click="onFilterChange" outlined>
            Tìm kiếm
          </v-btn>
        </div>
      </div>
    </v-row>
  </v-form>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import get from 'lodash-es/get'
import { textHelpers } from '@/helpers/TextHelper'
import utils from '@/plugins/utils'

export default {
  data: () => ({
    grade: {},
    show: false,
    status: 'active',
    tags_contains: '',
    classifes: [
      { name: 'Mặc định', value: 'default' },
      { name: 'Bổ sung', value: 'custom' }
    ],
    category: ''
  }),
  props: {
    defaultFilters: Object,
    type: String
  },
  computed: {
    ...mapState('constant', ['studentStatus']),
    ...mapState('tuitionFeeGroup', ['group']),
    ...mapState('constant', ['studentStatus']),
    classFilter() {
      return { grade: get(this.grade, 'id') }
    }
  },
  methods: {
    ...mapActions('tuitionFeeGroup', ['searchGroup']),
    async onFilterChange() {
      let params = {
        tags_contains: textHelpers.removeSpaces(utils.clearUnicode(this.tags_contains)),
        type: this.type
      }
      if(this.category) params.category = this.category;
      await this.searchGroup(params)
    },
    reset() {
      this.tags_contains = ''
      this.grade = {}
      this.show = false
    },
    addGroupSuccess() {
      this.category = this.group.category
      this.tags_contains = this.group.tags
    }
  },
  watch: {
    defaultFilters(filters) {
      if (filters) {
        this.code = get(filters, 'code')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
div.buttonSearch {
  width: 110px;
}
div.inputSearch {
  width: calc(100% - 120px - 12px);
}
@media screen and (max-width: 960px) {
  div.buttonSearch {
    width: 110px;
    padding-top: 24px;
    margin-left: 0px !important;
  }
  div.inputSearch {
    width: 100%;
    padding-right: 24px;
  }
}
</style>
